module.exports = {"451023100":"马头镇","451023101":"新安镇","451023102":"果化镇","451023103":"太平镇","451023104":"坡造镇","451023105":"四塘镇","451023106":"旧城镇","451023107":"榜圩镇","451023108":"凤梧镇","451023200":"海城乡","451023202":"黎明乡","451023203":"同老乡","451023450":"平果铝"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451023.json
// module id = 2144
// module chunks = 0